const backendUrl = "https://api357.cf.adapid.link/"
export const aadhar_payment_fraud = `${backendUrl}cs/api/aadhar/payment/fraud`
export const upi_fraud =  `${backendUrl}cs/api/upi/fraud`
export const business_email_compromise =`${backendUrl}cs/api/email/compromise`
export const credit_fraud =`${backendUrl}cs/api/credit/fraud`
export const demat_fraud =`${backendUrl}cs/api/demat/fraud`
export const ewallet_fraud =`${backendUrl}cs/api/ewallet/fraud`
export const fraud_call =`${backendUrl}cs/api/fraud/call`
export const internet_banking_fraud =`${backendUrl}cs/api/internet/banking/fraud`
export const payment_network_fraud = `${backendUrl}cs/api/payment/network/fraud`
export const request_status_tableData = `${backendUrl}cs/api/I4C/request/details`
export const request_status_response = `${backendUrl}cs/api/I4C/response/ack/details`
